import { reportDataType } from '@/enums/reportDataType'
import moment from 'moment'
import { defaultDateFormat } from '@/utils/dateUtilities'
import { isDefinedAndNotEmpty } from '@/utils/isDefined'
const reportDataTypeEnum = reportDataType.enum

export function validate (dataType, value) {
  function processValue () {
    switch (dataType) {
      case reportDataTypeEnum.String:
        break
      case reportDataTypeEnum.Integer:
      case reportDataTypeEnum.NumberUnformatted:
        if (!isDefinedAndNotEmpty(value)) {
          value = null
        } else if (!/^\d*$/.test(value)) {
          return 'Validations.InvalidNumber'
        }
        break
      case reportDataTypeEnum.Number:
      case reportDataTypeEnum.PercentageInt:
      case reportDataTypeEnum.PercentageDouble:
        if (!isDefinedAndNotEmpty(value)) {
          value = null
        } else if (!/^\d*\.?\d*$/.test(value)) {
          return 'Validations.InvalidNumber'
        }
        break
      case reportDataTypeEnum.Bool:
        if (/^(TRUE|1)$/i.test(value)) {
          value = 'True'
        } else if (/^(FALSE|0)$/i.test(value)) {
          value = 'False'
        } else if (!isDefinedAndNotEmpty(value)) {
          value = null
        } else {
          return 'Validations.InvalidFormat'
        }
        break
      case reportDataTypeEnum.Date:
        if (typeof value !== 'string') break
        const altFormat = value.match(/^([12]\d{3})-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/)
        if (altFormat) {
          value = moment(`${altFormat[3]}/${altFormat[2]}/${altFormat[1]}`, defaultDateFormat).toISOString()
        } else if (/^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/([12]\d{3})$/.test(value)) {
          value = moment(value, defaultDateFormat).toISOString()
        } else {
          return 'Validations.InvalidDate'
        }
        break
    }
    return null
  }
  const error = processValue()
  return {
    value,
    error
  }
}



// WEBPACK FOOTER //
// ./src/components/report-tables/core/validation.js